module.exports = __webpack_public_path__ + "img/app_logo.73a8f00e.png";